import { render, staticRenderFns } from "./BaseVue.vue?vue&type=template&id=4c1a8840&scoped=true"
import script from "./BaseVue.vue?vue&type=script&lang=js"
export * from "./BaseVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a8840",
  null
  
)

export default component.exports